<template>
	<div class="company-list">
		<app-table
			selectable
			class="mt-5 is-not-selectable"
			name="companies"
			:current-page="currentPage"
			:last-page="lastPage"
			:items-total-quantity="itemsTotalQuantity"
			:items-quantity="itemsQuantity"
			:columns="columns"
			:rows="rows"
			@on-page="$emit('on-page', $event)"
			@row-is-selected="$emit('row-is-selected', $event)"
			@on-search-event="onSearch"
		>
			<template slot="rows" slot-scope="props">
				<td v-show="showRow(columns, 1)" class="date">
					{{ props.row.startDateOperations | exactDate }}
				</td>
				<td v-show="showRow(columns, 2)" class="name">
					{{ props.row.name }}
				</td>
				<td v-show="showRow(columns, 3)" class="ruc">{{ props.row.documentNumber }}</td>
				<td v-show="showRow(columns, 4)" @click.stop="stopClick" class="actions">
					<app-tooltip-button
						class="no-movil"
						img="/static/img/icons/centro-costos.svg"
						text="Centros de Costos"
						color="cyan"
						:width="25"
						@click-icon="goToCostCenters(props.row)"
					/>
					<app-tooltip-button
						class="no-movil"
						img="/static/img/icons/plan-contable.svg"
						text="Ver Plan Contable"
						:width="25"
						@click-icon="goToAccountingPlans(props.row)"
					/>
					<app-tooltip-button
						class="no-movil"
						img="/static/img/icons/periodo-contable.svg"
						text="Periodos Contables"
						:width="25"
						@click-icon="goToAccountingPeriods(props.row)"
					/>
					<app-tooltip-button
						class="no-movil"
						img="/static/img/icons/modulo.svg"
						text="Módulos"
						:width="25"
						@click-icon="goToModules(props.row)"
					/>
					<app-tooltip-button
						class="no-movil"
						color="success"
						img="/static/img/actions-list/edit.svg"
						text="Editar Empresa"
						:width="25"
						@click-icon="edit(props.row)"
					/>
					<app-tooltip-button
						class="no-movil"
						img="/static/img/actions-list/delete.svg"
						text="Eliminar Empresa"
						:width="25"
						@click-icon="$emit('delete-company', props.row)"
					/>
					<div
						class="collapse-menu"
					>
						<v-menu>
							<v-btn dark icon slot="activator">
								<v-icon>more_horiz</v-icon>
							</v-btn>
							<v-list>
								<v-list-tile class="btn-menu-content">
									<v-list-tile-title class="menu-content" @click="goToCostCenters(props.row)">
										<img
											src="/static/img/icons/centro-costos.svg"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
										>
										<span class="ml-1 cost-center">Centro de costos</span>
									</v-list-tile-title>
								</v-list-tile>
								<v-list-tile class="btn-menu-content">
									<v-list-tile-title class="menu-content" @click="goToAccountingPlans(props.row)">
										<img
											src="/static/img/icons/plan-contable.svg"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
										>
										<span class="ml-1 accounting-plan">Ver Plan Contable</span>
									</v-list-tile-title>
								</v-list-tile>
								<v-list-tile class="btn-menu-content">
									<v-list-tile-title class="menu-content" @click="goToAccountingPeriods(props.row)">
										<img
											src="/static/img/icons/periodo-contable.svg"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
										>
										<span class="ml-1 accounting-periods">Periodos Contables</span>
									</v-list-tile-title>
								</v-list-tile>
								<v-list-tile class="btn-menu-content">
									<v-list-tile-title class="menu-content" @click="goToModules(props.row)">
										<img
											src="/static/img/icons/modulo.svg"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
										>
										<span class="ml-1 modules">Módulos</span>
									</v-list-tile-title>
								</v-list-tile>
								<v-list-tile class="btn-menu-content">
									<v-list-tile-title class="menu-content" @click="edit(props.row)">
										<img
											src="/static/img/icons/edit.svg"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
										>
										<span class="ml-1 edit">Editar empresa</span>
									</v-list-tile-title>
								</v-list-tile>
								<v-list-tile>
									<v-list-tile-title class="menu-content" @click="$emit('delete-company', props.row)">
										<img
											src="/static/img/actions-list/delete.svg"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
										>
										<span class="ml-1">Eliminar</span>
									</v-list-tile-title>
								</v-list-tile>
							</v-list>
						</v-menu>
					</div>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import appTooltipButton from '@/components/shared/app-tooltip-button';

function edit(company) {
	const { customerId, id } = company;
	const { customerName } = this.$route.params;
	this.goTo('company-edit', { params: { customerId, companyId: id, customerName } });
}

function goToAccountingPlans(company) {
	const { id } = company;
	this.$setCurrentSubsidiary(company);
	this.goTo('accounting-plans', { params: { subsidiaryId: id } });
}

function goToAccountingPeriods(company) {
	const { id, name } = company;
	this.$setCurrentSubsidiary(company);
	this.goTo('accounting-periods', { params: { subsidiaryId: id, subsidiaryName: name.split(' ').join('-') } });
}

function goToCostCenters(company) {
	const { id, name } = company;
	this.$setCurrentSubsidiary(company);
	this.goTo('costs-centers', { query: { subsidiaryId: id, subsidiaryName: name.split(' ').join('-') } });
}

function goToModules(company) {
	const { customerId, id, name } = company;
	this.$setCurrentSubsidiary(company);
	this.goTo('accounting-modules', { query: { subsidiaryId: id, name, customerId } });
}

function onSearch(value) {
	this.$emit('on-search', value);
}
function data() {
	return {
		iconWidth: 10,
	};
}
export default {
	name: 'company-list',
	components: {
		appTooltipButton,
	},
	data,
	props: {
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		itemsTotalQuantity: {
			type: Number,
			default: 1,
		},
		itemsQuantity: {
			type: Number,
			default: 1,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
	methods: {
		...mapActions('subsidiary', {
			$setCurrentSubsidiary: 'setCurrentSubsidiary',
		}),
		edit,
		goToAccountingPeriods,
		goToAccountingPlans,
		goToCostCenters,
		goToModules,
		onSearch,
	},
};
</script>
<style lang="scss" scoped>
	.company-list {
		font-family: font(AvenirRegular) !important;
		font-size: size(small11) !important;
		padding-left: 48px;
		padding-right: 48px;

		@media (max-width: 768px) {
			padding-left: 10px;
			padding-right: 10px;
		}
	}

	.date {
		@media (max-width: 768px) {
			display: grid;
			grid-column: 1/4;
			grid-row: 2;
			white-space: nowrap;
		}
	}

	.name {
		@media (max-width: 768px) {
			display: flex;
			grid-column: 2/7;
			grid-row: 1;
			justify-content: center;
			padding-left: 0px !important;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}

	.company-name {
		display: none;

		@media (max-width: 768px) {
			display: inline-block;
			font-family: font(AvenirBold);
			margin-right: 15px;
		}
	}

	.ruc {
		@media (max-width: 768px) {
			display: grid;
			grid-column: 4/8;
			grid-row: 2;
		}
	}

	.actions {
		@media (max-width: 768px) {
			grid-column: 7/8;
			grid-row: 1;
		}
	}

	.btn-menu-content {
		border-bottom: 1px solid color(grey-background-table);
	}

	.menu-content {
		align-items: center;
		color: color(red-icon);
		display: grid;
		font-family: font(AvenirRegular);
		font-size: size(small) !important;
		grid-column-gap: 3px;
		grid-template-columns: 15px 1fr;
		width: 175px;

		.cost-center,
		.accounting-plan,
		.accounting-periods,
		.modules {
			color: color(secondary);
		}

		.edit {
			color: color(btn-green);
		}
	}

	.collapse-menu {
		display: none;

		@media (max-width: 768px) {
			align-items: center;
			display: block;
			grid-column: 2/3;
			grid-row: 1;
			height: 100%;
			justify-content: center;

			.v-menu {
				align-items: center;
				display: flex;
				height: 100%;
				justify-content: center;

				.v-btn {
					background-color: color(btn-green);
					height: 25px;
					margin: 0;
					width: 25px;
				}
			}

		}
	}
	.btnActions {
		margin: 0;
		background-color:#33cfc7;
		height:20px;
		width:20px;
	}
	.btnClose {
		margin: 0;
		background-color: #f58a93;;;
		height:20px;
		width:20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/companies/company-list.vue